import { Link } from 'react-router-dom';
import { company } from '../../data/company';
import tecnvironsLogo from '../../assets/images/Tecnvirons-logo.jpeg';
import './Footer.css';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container footer-inner">
        <div className="footer-top">
          <div className="footer-brand">
            <div className="footer-brand-name">
              <img src={tecnvironsLogo} alt="Tecnvirons" className="footer-logo" />
            </div>
            <p>
              One platform for appointments, workforce, customers, and recurring service —
              built for RO servicing, vending, AC &amp; fridge repair, medical equipment
              maintenance, and civil construction businesses.
            </p>
            <a className="btn btn-secondary footer-whatsapp" href={company.whatsappLink} target="_blank" rel="noopener noreferrer">
              <svg viewBox="0 0 48 48" width="22" height="22" aria-hidden="true" focusable="false">
                <path
                  fill="#25D366"
                  d="M24 4C12.954 4 4 12.954 4 24c0 3.96 1.146 7.653 3.127 10.766L4.4 43.6l9.06-2.677A19.9 19.9 0 0 0 24 44c11.046 0 20-8.954 20-20S35.046 4 24 4z"
                />
                <path
                  fill="#fff"
                  d="M34.87 28.24c-.47-.235-2.78-1.372-3.21-1.53-.43-.157-.744-.235-1.058.235-.313.47-1.215 1.53-1.49 1.844-.274.313-.548.353-1.018.118-.47-.235-1.984-.732-3.78-2.334-1.397-1.246-2.34-2.785-2.615-3.256-.274-.47-.03-.724.206-.958.212-.21.47-.548.705-.822.235-.274.313-.47.47-.784.157-.313.078-.588-.04-.822-.117-.235-1.057-2.548-1.45-3.49-.382-.918-.77-.793-1.058-.807-.274-.014-.588-.017-.902-.017-.313 0-.822.118-1.253.588-.43.47-1.646 1.61-1.646 3.923 0 2.313 1.685 4.548 1.92 4.862.235.313 3.316 5.065 8.033 7.102 1.122.484 1.997.773 2.68.99 1.126.358 2.152.307 2.963.186.904-.135 2.78-1.137 3.172-2.235.392-1.098.392-2.04.274-2.235-.117-.196-.43-.313-.902-.548z"
                />
              </svg>
              Message us on WhatsApp
            </a>
          </div>

          <div className="footer-col">
            <h4>Site</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/industries">Industries</Link></li>
              <li><Link to="/platform">Platform</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Legal</h4>
            <ul>
              <li><Link to="/terms-of-service">Terms of Service</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Contact</h4>
            <ul>
              <li><a href={`mailto:${company.email}`}>{company.email}</a></li>
              {company.offices.map((office) => (
                <li key={office.label}>
                  <a href={`tel:${office.phone.replace(/[^+\d]/g, '')}`}>{office.phone}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {year} Tecnvirons. All rights reserved.</p>
          <div className="footer-social">
            <a href={company.social.linkedin} target="_blank" rel="noopener noreferrer">LinkedIn</a>
            <a href={company.social.twitter} target="_blank" rel="noopener noreferrer">X</a>
            <a href={company.social.facebook} target="_blank" rel="noopener noreferrer">Facebook</a>
            <a href={company.social.instagram} target="_blank" rel="noopener noreferrer">Instagram</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
